<template>
    <v-dialog v-model="$store.state.bookings.deleteBookingDialog" width="500">
        <v-card>
            <v-card-title class="red white--text" primary-title>Are you sure you want to delete this booking?</v-card-title>
            <v-card-text>
                <h5 class="title">This action cannot be undone</h5>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="confirmDelete"><v-icon left>mdi-delete</v-icon>Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {BookingsHttp} from "../../../http/bookings";
    import {EventBus} from "../../../EventBus";

    export default {
        name: "DeleteBookingDialog",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            booking: {
                get() {
                    return this.$store.state.bookings.activeBooking;
                }
            }
        },
        methods: {
            closeDialog() {
                this.$store.dispatch('bookings/resetActiveBooking');
                this.$store.dispatch('bookings/setDeleteBookingDialog', false);
                this.$store.dispatch('bookings/setBookings', {day: this.$moment().startOf('isoWeek').toDate(), isWeek: true});
            },
            async confirmDelete() {
                this.isLoading = true;
                try {
                    await BookingsHttp.deleteBooking(this.booking._id);
                    this.closeDialog();
                    EventBus.$emit('message', {message: 'Booking deleted successfully', type: 'success'});
                } catch (e) {
                    EventBus.$emit('message', {message: e, type: 'error'});
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
